import { FaRegCircleCheck } from "react-icons/fa6";
import { useSelector } from "react-redux";

const OrderSuccess = () => {
  //  const {finishedOrder} = useSelector((store: any) => store.order);
  //  console.log(finishedOrder)

  return (
    <div>
      <FaRegCircleCheck
        style={{
          fontSize: "150px",
          color: "green",
          marginBottom: "1%",
        }}
      />
      <h2>Vaša narudžba je uspješno kreirana!</h2>
    </div>
  );
};
export default OrderSuccess;
